import React from 'react';
import img1 from '../../../assets/t1.png';
import img2 from '../../../assets/t2.png';
import img3 from '../../../assets/t3.png';
import img4 from '../../../assets/t4.png';
import { FaGithub } from "react-icons/fa";
import { FaLinkedinIn } from "react-icons/fa";
import { FaFile } from "react-icons/fa";

const SinglePage1 = () => {
    return (
        <div>
            
        <div class="md:flex items-start justify-center py-12 2xl:px-20 md:px-6 px-4 pt-24">
            <div class="xl:w-2/6 lg:w-2/5 w-full lg:w-80 md:block">
                <img class="w-full" alt="image of a girl posing" src={img1} />
                <img class="mt-6 w-full" alt="image of a girl posing" src={img2} />
                <img class="mt-6 w-full" alt="image of a girl posing" src={img3} />
            </div> 
            {/* <div class="md:hidden">
                <img class="w-full" alt="image of a girl posing" src="https://i.ibb.co/QMdWfzX/component-image-one.png" />
                <div class="flex items-center justify-between mt-3 space-x-4 md:space-x-0">
                    <img alt="image-tag-one" class="md:w-48 md:h-48 w-full" src="https://i.ibb.co/cYDrVGh/Rectangle-245.png" />
                    <img alt="image-tag-one" class="md:w-48 md:h-48 w-full" src="https://i.ibb.co/f17NXrW/Rectangle-244.png" />
                    <img alt="image-tag-one" class="md:w-48 md:h-48 w-full" src="https://i.ibb.co/cYDrVGh/Rectangle-245.png" />
                    <img alt="image-tag-one" class="md:w-48 md:h-48 w-full" src="https://i.ibb.co/f17NXrW/Rectangle-244.png" />
                </div>
            </div> */}
            <div class="xl:w-2/5 md:w-1/2 lg:ml-8 md:ml-6 md:mt-0 mt-6">
                
                <h2 className='text-7xl font-bold'>Tree-Pagla</h2>
                <div>
                    <p class=" text-base lg:leading-tight leading-normal text-gray-600 dark:text-gray-300 mt-7">Tree-Pagla – Gardening, Lawn Landscaping HTML Template build for Lawn Services Business, Landscaping Companies, Groundskeepers, Landscape Architects, Gardening Business, Florists, firewood, flowers, ecology, landscape, lawn, lumberjack, Big or Small Gardener Business, Agriculture and companies that offer related services.It has 100% responsive design and tested on all major handheld devices.</p>
                    <p class=" text-base lg:leading-tight leading-normal text-gray-600 dark:text-gray-300 mt-7">
                    Tree-pagla  stand out from the crowd and that will turn your visitors in to customers. If your company are Lawn Services Business, Landscaping Companies, Small Gardener Business, Agriculture or all of that together, you’ll certainly find a layout that will fit your needs</p>
                    <h4 className='text-4xl font-semibold mt-10 mb-4'>Features:</h4>
                    <ul className='text-gray-600'>
                        <li>1.Responsive Unique Layout</li>
                        <li>2.Has Login System With FireBase</li>
                        <li>3.Used Tailwind Css for creating this beautiful website</li>
                        <li>4.Data Stored in MongoDb</li>
                        <li>5.Used Express and Node to Create Server API</li>
                        <li>6.It has a review form</li>
                        <li>7.Also hav a add service form</li>
                        <li>8.Own reviews can be edit and delete.</li>
                    </ul>
                    <p class="text-base leading-4 mt-7 text-gray-600 dark:text-gray-300">Live Link: <a href="https://tree-pagla.web.app/" target="_blank" className='text-lime-600'>https://tree-pagla.web.app/</a></p>
                    <p class="text-base leading-4 mt-7 text-gray-600 dark:text-gray-300">GitHub Code Link: <a href="https://github.com/devmonika/Tree-pagla" className='text-lime-600' target="_blank">https://github.com/devmonika/Tree-pagla</a></p>
                </div>
                <div>
                    <div class="border-t border-b py-4 mt-7 border-gray-200">
                        <div data-menu class="flex justify-between items-center cursor-pointer">
                            <div className='text-gray-600 flex'>
                            <a className='text-3xl text-lime-600' href='https://github.com/devmonika'><FaGithub></FaGithub></a>
                            <a className='text-3xl text-lime-600 px-5' href='https://www.linkedin.com/in/monika-hossan-momi/'><FaLinkedinIn></FaLinkedinIn></a>
                            <a className='text-3xl text-lime-600' href='Resume.pdf' download><FaFile></FaFile></a>
                            </div>
                            
                        </div>
                    </div>
                </div>
                {/* <div>
                    <div class="border-b py-4 border-gray-200">
                        <div data-menu class="flex justify-between items-center cursor-pointer">
                            <p class="text-base leading-4 text-gray-800 dark:text-gray-300">Contact us</p>
                            <button class="cursor-pointer focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-400 rounded" role="button" aria-label="show or hide">
                                <img class="transform dark:hidden" src="https://tuk-cdn.s3.amazonaws.com/can-uploader/productDetail3-svg4.svg" alt="dropdown"/>
                                <img class="transform hidden dark:block" src="https://tuk-cdn.s3.amazonaws.com/can-uploader/productDetail3-svg4dark.svg" alt="dropdown"/>
                            </button>
                        </div>
                        <div class="hidden pt-4 text-base leading-normal pr-12 mt-4 text-gray-600 dark:text-gray-300" id="sect">If you have any questions on how to return your item to us, contact us.</div>
                    </div>
                </div> */}
            </div>
        </div>
      
      
    
        </div>
    );
};

export default SinglePage1;